import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo_transbg.png';
import { trackSignupFree } from '../utils/analytics.js';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="announcement-bar">
        🚀 Free During Beta • No Credit Card Required • Start Collecting Video Testimonials in Under 2 Minutes
      </div>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container navbar-container">
          <Link to="/" className="navbar-logo">
            <img src={logo} alt="Clientalio Logo" className="logo-image" />
          </Link>

          <button className="menu-toggle" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            <li><Link to="/features" onClick={() => setIsMenuOpen(false)}>Features</Link></li>
            <li><Link to="/integration" onClick={() => setIsMenuOpen(false)}>Integration</Link></li>
            <li><Link to="/testimonials" onClick={() => setIsMenuOpen(false)}>Testimonials</Link></li>
            <li><Link to="/wall-of-love" onClick={() => setIsMenuOpen(false)}>Wall of love</Link></li>
            <li><Link to="/blog" onClick={() => setIsMenuOpen(false)}>Blog</Link></li>
            <li><Link to="/pricing" onClick={() => setIsMenuOpen(false)}>Pricing</Link></li>
          </ul>

          <div className="navbar-actions">
            <Link to="/signup" className="btn-signup" onClick={() => trackSignupFree('navbar')}>Signup Now</Link>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
